import { render, staticRenderFns } from "./editdelivery.vue?vue&type=template&id=001b4478&scoped=true&"
import script from "./editdelivery.vue?vue&type=script&lang=js&"
export * from "./editdelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001b4478",
  null
  
)

export default component.exports